/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Drawer, MenuItem} from '@material-ui/core';

/**
 * region for styles*/
import { layoutKeywordStyle } from './style/layoutKeywordStyle';

/**
 * region for containers*/
import MenuKeyword from '../../../containers/keyword/MenuKeyword';
import HeaderKeyword from '../../../containers/keyword/HeaderKeyword';
import Keyword from '../../../containers/keyword/Keyword';
import DetailKeyword from '../../../containers/keyword/DetailKeyword';
import MessageModal from '../../../components/common/MessageModal';

/**
 * region for hepers*/
import ajax from '../../../helpers/ajax';
import typing from '../../../helpers/typing';
import list from '../../../helpers/list'

/**
 * region for constans*/
import Constants from '../../../constants/Constants';

class LayoutKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openDetails: false,
            searchKeyword: '',
            keywordsFound: [],
            totalFound: 0,
            pageSize: 50,
            pageNumber: 1,
            keywordSelect: null,
            selectedTab: 0,
            UrlBase: [],
            typeFilter: 1,
            mode: Constants.MODE_VIEW,
            isSelectAll: false,
            showMenu: false,
            titleSearchKeyword: 'Keyword Management',
            staff: [],
            currentlyStaffSelect: null,
            checkInsufficientContent: false,
            checkEqualToCategory: false,
            showModalKeywordsAdded: false,
            countKeywordsAdded:0
        };
    }

    componentDidMount() {
        this.load();
    }

    load() {
        const self = this;
        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_STAFF,
            {
                success: function (response) {
                    self.setState({
                        staff: response.data
                    });
                }
            });
    }

    toggleDrawerDetails(open, event) {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.setState({ openDetails: open });
    }

    handleDrawerDetailsOpen(keyword) {
        let self = this;
        if (keyword != null) {
            self.setState({ openDetails: true, keywordSelect: keyword });
        }
    }

    handleChange(event) {
        event.preventDefault();
        this.setState({
            searchKeyword: event.target.value
        });
    }

    searchFilter() {
        let self = this;

        if (!typing.isEmpty(self.state.searchKeyword) || self.state.currentlyStaffSelect >= 0) {
            self.setState({ mode: Constants.MODE_LOADING },
                function () {
                    window.localStorage.removeItem("keywords")
                    const requestData = {
                        keyword: self.state.searchKeyword,
                        checkInsufficientContent: self.state.checkInsufficientContent,
                        checkEqualToCategory: self.state.checkEqualToCategory,
                        pageNumber: 1,
                        pageSize: self.state.pageSize,
                        typeFilter: 1
                    };

                    if (self.state.currentlyStaffSelect > 0) {
                        Object.assign(requestData, { idStaff: self.state.currentlyStaffSelect });
                    }

                    ajax.get(Constants.ROUTE_API_CONTENT_SEARCH_BY_KEYWORD,
                        {
                            requestData: requestData,
                            success: function (response) {

                                const keywordsFound = response.data.map(keyword => {
                                    return { ...keyword, CHECKED: false }
                                })

                                self.setState({
                                    pageNumber: 1, keywordsFound: keywordsFound, totalFound: response.totalCount,
                                    mode: Constants.MODE_LOADED, isSelectAll: false, typeFilter: 1
                                }, () => {
                                    self.handleActionShowHideMenu()
                                })
                            }
                        });
                });
        }
    }

    handleChangePage(event, newPage) {
        event.preventDefault();
        const self = this;
        if (!typing.isEmpty(self.state.searchKeyword) || self.state.currentlyStaffSelect >= 0) {
            const pageNumber = newPage + 1;
            const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
            const requestData = {
                keyword: self.state.searchKeyword,
                checkInsufficientContent: self.state.checkInsufficientContent,
                checkEqualToCategory: self.state.checkEqualToCategory,
                pageNumber: pageNumber,
                pageSize: self.state.pageSize,
                typeFilter: self.state.typeFilter
            };

            if (self.state.currentlyStaffSelect > 0) {
                Object.assign(requestData, { idStaff: self.state.currentlyStaffSelect });
            }

            ajax.get(Constants.ROUTE_API_CONTENT_SEARCH_BY_KEYWORD,
                {
                    requestData: requestData,
                    success: function (response) {

                        let keywordsFound = []
                        let isSelectAll = null

                        if (getKeywordInLocalStorage !== null) {
                            keywordsFound = response.data.map(keyword => {
                                const isCheked = getKeywordInLocalStorage.map(x => x.IDKEYWORD).includes(keyword.IDKEYWORD)
                                return { ...keyword, CHECKED: isCheked, PAGENUMBER: pageNumber }
                            })

                            let checkSelectAll = keywordsFound.length === keywordsFound.filter(x => x.PAGENUMBER === pageNumber && x.CHECKED === true).length
                            isSelectAll = checkSelectAll

                        } else {
                            keywordsFound = response.data.map(keyword => { return { ...keyword, CHECKED: false, PAGENUMBER: pageNumber } })
                            isSelectAll = false
                        }

                        self.setState({
                            pageNumber: pageNumber, keywordsFound: keywordsFound,
                            totalFound: response.totalCount, isSelectAll: isSelectAll, mode: Constants.MODE_LOADED
                        })
                    }
                });
        }
    };

    handleActionShowHideMenu() {
        const self = this;
        const { keywordsFound } = self.state;
        const totalKeywordsWithCategory = keywordsFound.filter(x => x.TOTALRELATED > 0).length
        const totalKeywordsWithOutCategory = keywordsFound.filter(x => x.TOTALNOTRELATED > 0).length

        if (totalKeywordsWithCategory > 0 && totalKeywordsWithOutCategory > 0) {
            self.setState({ showMenu: true })
        } else {
            self.setState({ showMenu: false })
        }
    }

    handleOnRefreshSearchFilter(page) {

        const self = this;

        if (!typing.isEmpty(self.state.searchKeyword) || self.state.currentlyStaffSelect >= 0) {

            self.setState({ mode: Constants.MODE_LOADING })
            window.localStorage.removeItem("keywords")
            const requestData = {
                keyword: self.state.searchKeyword,
                checkInsufficientContent: self.state.checkInsufficientContent,
                checkEqualToCategory: self.state.checkEqualToCategory,
                pageNumber: page,
                pageSize: self.state.pageSize,
                typeFilter: self.state.typeFilter
            };

            if (self.state.currentlyStaffSelect > 0) {
                Object.assign(requestData, { idStaff: self.state.currentlyStaffSelect });
            }

            ajax.get(Constants.ROUTE_API_CONTENT_SEARCH_BY_KEYWORD,
                {
                    requestData: requestData,
                    success: function (response) {
                        const keywordsFound = response.data.map(keyword => { return { ...keyword, CHECKED: false } })
                        self.setState({ pageNumber: page, keywordsFound: keywordsFound, totalFound: response.totalCount, mode: Constants.MODE_LOADED, isSelectAll: false })
                    }
                });
        }
    }

    onChangeSelectStaff(event) {
        event.preventDefault();
        const self = this;
        self.setState({
            currentlyStaffSelect: event.target.value
        }, function () {
            self.searchFilter();
        });
    }

    onKeyPressSearchFilter(event) {
        const self = this;
        if (event.which === 13) {
            self.searchFilter();
        }
    }

    handleChangeCheckInsufficientContent(event) {
        const self = this;
        const isChecked = event.target.checked;
        self.setState({
            checkInsufficientContent: isChecked
        },
        function(){
            self.handleOnRefreshSearchFilter(1);
        })
    }

    handleChangeCheckEqualToCategory(event) {
        const self = this;
        const isChecked = event.target.checked;
        self.setState({
            checkEqualToCategory: isChecked
        },
        function(){
            self.handleOnRefreshSearchFilter(1);
        })
    }

    handleChangeFiltersKeyword() {
        
    }

    handleChangeCheckbox(keyword) {

        const self = this;
        const { keywordsFound } = self.state;

        const isChecked = !keyword.CHECKED;

        if (isChecked === false) {
            this.onRemoveIdKeywordInLocalStorage(keyword)
        }

        const newkeywordsFound = keywordsFound.map(keywordFound => {
            if (keywordFound.IDKEYWORD === keyword.IDKEYWORD) {
                return { ...keywordFound, CHECKED: isChecked }
            } else {
                return { ...keywordFound }
            }
        });

        this.onSaveKeywordInLocalStorage(newkeywordsFound)
        self.setState({ keywordsFound: newkeywordsFound });
    }

    onRemoveIdKeywordInLocalStorage(keyword) {
        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
        if (getKeywordInLocalStorage !== null) {
            window.localStorage.setItem("keywords", JSON.stringify(getKeywordInLocalStorage.filter(k => k.IDKEYWORD !== keyword.IDKEYWORD)))
        }
    }

    onRemoveMultiplesKeywordsInLocalStorage(pageNumber) {
        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
        if (getKeywordInLocalStorage !== null) {
            window.localStorage.setItem("keywords", JSON.stringify(getKeywordInLocalStorage.filter(k => k.PAGENUMBER !== pageNumber)))
        }
    }

    onSaveKeywordInLocalStorage(newkeywordsFound) {

        const { pageNumber } = this.state

        const listKeywords = newkeywordsFound.filter(x => x.CHECKED === true).map(x => {
            return {
                IDKEYWORD: x.IDKEYWORD,
                WITHOUTCATEGORY: x.WITHOUTCATEGORY,
                KEYWORD: x.KEYWORD,
                PAGENUMBER: pageNumber
            }
        })

        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))

        if (getKeywordInLocalStorage === null) {
            window.localStorage.setItem("keywords", JSON.stringify(listKeywords))
        } else {
            const resultKewords = list.removeDuplicatesByObject(listKeywords.concat(getKeywordInLocalStorage), 'IDKEYWORD')
            window.localStorage.setItem("keywords", JSON.stringify(resultKewords))
        }
    }

    handleRelateKeywords() {
        const self = this;
        const { pageNumber } = self.state
        self.handleOnRefreshSearchFilter(pageNumber)
    }

    handleUnrelateKeywords() {
        const self = this;
        const { pageNumber } = self.state
        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
        const getKeywords = getKeywordInLocalStorage.filter(x => x.WITHOUTCATEGORY === 0).map(x => x.IDKEYWORD);

        ajax.put(Constants.ROUTE_API_CONTENT_KEYWORDS_CATEGORIES_LIST,
            {
                requestData: {
                    IdList: getKeywords
                },
                success: function (response) {
                    self.handleOnRefreshSearchFilter(pageNumber)
                }
            });
    }

    handleDeleteKeywords() {
        const self = this;
        const { pageNumber } = self.state
        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
        const getKeywords = getKeywordInLocalStorage.map(x => x.IDKEYWORD);

        ajax.delete(Constants.ROUTE_API_CONTENT_KEYWORDS_CATEGORIES_LIST,
            {
                requestData: {
                    IdList: getKeywords
                },
                success: function (response) {
                    self.handleOnRefreshSearchFilter(pageNumber)
                }
            });
    }

    handleSearchAllTerms() {
        const self = this;
        self.setState({ typeFilter: 1 }, () => {
            self.handleOnRefreshSearchFilter(1)
        })
    }

    handleSearchRelatedTerms() {
        const self = this;
        self.setState({ typeFilter: 2 }, () => {
            self.handleOnRefreshSearchFilter(1)
        })
    }

    handleSearchUnRelatedTerms() {
        const self = this;
        self.setState({ typeFilter: 3 }, () => {
            self.handleOnRefreshSearchFilter(1)
        })
    }

    handleClickSelectAll(isSelectAll) {
        const self = this;
        const { keywordsFound, pageNumber } = self.state;
        const getAllKeywordsBySelection = keywordsFound.map(x => { return { ...x, CHECKED: isSelectAll } })
        self.setState({ isSelectAll: isSelectAll, keywordsFound: getAllKeywordsBySelection }, () => {
            if (isSelectAll) {
                this.onSaveKeywordInLocalStorage(getAllKeywordsBySelection)
            } else {
                this.onRemoveMultiplesKeywordsInLocalStorage(pageNumber)
            }
        })
    }

    handleResearchKeyword() {
        const self = this;
        const { pageNumber } = self.state
        const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))

        let idKeywordList = getKeywordInLocalStorage.filter(x => x.WITHOUTCATEGORY === 0).map(x => x.IDKEYWORD);
            
        const requestData = {
            keywords: idKeywordList
        };

        ajax.put(Constants.ROUTE_API_RESEARCH_TASK,
            {
                requestData: requestData,
                success: function () {
                    self.setState({
                        showModalKeywordsAdded: true,
                        countKeywordsAdded:idKeywordList.length
                    });
                    self.handleOnRefreshSearchFilter(pageNumber)
                }
            });
    }

    handleCloseModal() {
        
        this.setState({
            showModalKeywordsAdded: false,
            countKeywordsAdded: 0
        });
    }
    render() {
        const self = this;
        const { typeFilter, showMenu } = this.state;
        const { classes } = this.props;

        const selectListStaff = this.state.staff;
        let selectStaff = [];
        selectStaff.push(<MenuItem value={0} key={0}>All Staff</MenuItem>);
        if (Object.keys(selectListStaff).length > 0) {
            selectStaff.push(selectListStaff.map((item, index) =>
                <MenuItem value={item.IDSTAFF} key={index}>{item.STAFF}</MenuItem>
            ));
        }

        let showModal;
        if (this.state.showModalKeywordsAdded) {
            let count=self.state.countKeywordsAdded;
            let text=''+ count +' keywords have been added to the research queue';
            showModal =  <MessageModal
                            title={"Message"}
                            text={text}
                            onClose={this.handleCloseModal.bind(this)}
                            className="modal-md"
                        />
        }

        return (
            <div className={classes.root}>
                <AppBar className={clsx(classes.appBar)}
                    position="absolute"
                    color="inherit"
                    elevation={0}>
                    <HeaderKeyword
                        titleSearchKeyword={this.state.titleSearchKeyword}
                        searchKeyword={this.state.searchKeyword}
                        checkInsufficientContent= {this.state.checkInsufficientContent}
                        handleChangeCheckInsufficientContent= {this.handleChangeCheckInsufficientContent.bind(this)}
                        checkEqualToCategory= {this.state.checkEqualToCategory}
                        handleChangeCheckEqualToCategory= {this.handleChangeCheckEqualToCategory.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                        onKeyPressSearchFilter={this.onKeyPressSearchFilter.bind(this)}
                        onChangeSelectStaff={this.onChangeSelectStaff.bind(this)}
                        selectStaff={selectStaff} />
                </AppBar>
                {
                    showMenu && (
                        <Drawer classes={{ paper: clsx(classes.drawerPaper) }}
                            open={true}
                            variant="permanent">
                            <MenuKeyword
                                selectedIndex={typeFilter}
                                handleSearchAllTerms={this.handleSearchAllTerms.bind(this)}
                                handleSearchRelatedTerms={this.handleSearchRelatedTerms.bind(this)}
                                handleSearchUnRelatedTerms={this.handleSearchUnRelatedTerms.bind(this)}
                            />
                        </Drawer>
                    )
                }
                <div className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Keyword
                        totalFound={this.state.totalFound}
                        keywordsFound={this.state.keywordsFound}
                        pageSize={this.state.pageSize}
                        pageNumber={this.state.pageNumber}
                        mode={this.state.mode}
                        isSelectAll={this.state.isSelectAll}
                        handleChangePage={this.handleChangePage.bind(this)}
                        handleDrawerDetailsOpen={this.handleDrawerDetailsOpen.bind(this)}
                        handleChangeCheckbox={this.handleChangeCheckbox.bind(this)}
                        handleRefreshRelateKeywords={this.handleRelateKeywords.bind(this)}
                        handleOnClickConfirmUnrelate={this.handleUnrelateKeywords.bind(this)}
                        handleOnClickConfirmDelete={this.handleDeleteKeywords.bind(this)}
                        handleClickSelectAll={this.handleClickSelectAll.bind(this)}
                        handleOnClickConfirmResearch={this.handleResearchKeyword.bind(this)}

                    />
                </div>
                <Drawer classes={{ paper: clsx(classes.drawerDetailsPaper) }}
                    anchor="right"
                    open={this.state.openDetails}
                    onClose={this.toggleDrawerDetails.bind(this, false)}>
                    <DetailKeyword
                        keywordSelect={this.state.keywordSelect} />
                </Drawer>
                {showModal}
            </div>
        );
    }
}
LayoutKeyword.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(layoutKeywordStyle)(LayoutKeyword);